import VideoPlayer from '@components/Video/VideoPlayer';
import {
  IVideoPimResponsive,
  TImage,
  TVideo,
  IVideoPim,
  TFullResponsiveVideo,
  TMediaFit,
} from '@components/typescript';
import GetImageAlt from '@utils/getImageAlt';
import { BLANK_VIDEO_OBJECT } from '@features/cms/const';
import isVideoUrl from '@utils/isVideoUrl';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';

const RenderMedia = (
  images: TImage,
  videos: IVideoPimResponsive | TVideo = BLANK_VIDEO_OBJECT,
  playVideo = true,
  imagesWithBlur:
    | {
        blur: TImage;
        image: TImage;
      }
    | undefined = undefined,
  alt = '',
  priority = false,
  objectFit: TMediaFit = 'cover',
) => {
  let hasImages = false;
  if (!images) return false;
  const { desktop, tablet, mobile } = images;

  const isVideoPim = (video: unknown): video is IVideoPim =>
    typeof video === 'object' && video !== null && 'data' in video;

  const desktopVideo = videos && typeof videos !== 'string' ? videos.desktop : null;
  const hasDesktopVideo =
    desktopVideo && (typeof desktopVideo === 'string' || (isVideoPim(desktopVideo) && isVideoUrl(desktopVideo.data)));

  const getAlt = GetImageAlt(images) || alt || '';

  if (hasDesktopVideo) {
    return (
      <VideoPlayer
        video={videos as TFullResponsiveVideo}
        playVideo={playVideo}
        loop
        poster={imagesWithBlur}
        priority={priority}
        alt={getAlt}
      />
    );
  }

  if (!desktop) return <></>;
  if (desktop && tablet && mobile) {
    if (typeof desktop === 'string' && desktop !== '' && tablet !== '' && mobile !== '') hasImages = true;
    if (
      typeof desktop !== 'string' &&
      typeof tablet !== 'string' &&
      typeof mobile !== 'string' &&
      desktop.path !== '' &&
      tablet.path !== '' &&
      mobile.path !== ''
    )
      hasImages = true;
  }

  if (hasImages && imagesWithBlur) {
    return (
      <ResponsiveImage
        image={imagesWithBlur.image}
        blur={imagesWithBlur.blur}
        alt={getAlt}
        priority={priority}
        objectFit={objectFit}
      />
    );
  }

  if (typeof desktop === 'string' ? desktop : desktop.path) {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <ResponsiveImage image={images} alt={getAlt} blur={imagesWithBlur?.blur} objectFit={objectFit} />
      </div>
    );
  }
  return <></>;
};

export default RenderMedia;
